// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-2hKZc","documents":"documents-3sneB","document":"document-jBOJd","format":"format-g3bLW"};